import "./NoticeItem.scoped.scss"

function NoticeItem() {
  return (
    <div className="notice-item">
      <div className="notice-item__title">BLACKCHIP365 NOTICE</div>
      <div className="notice-item__contents">
        <p>- 광고성 채팅은 차단합니다</p>
        <p>- 상대 비방, 반말 또는 욕설</p>
        <p>- 비매너 채팅</p>
        <p>- 회원간 싸움 및 분란 조장</p>
        <p>- 운영진의 판단하에 운영정책에 위배되는 행위</p>
      </div>
    </div>
  );
}

export default NoticeItem;